'use strict';

import { getStatusLabel } from '../../filters/format-group-invoice-status';

class GroupInvoicesController {
  /* @ngInject */
  constructor(
    GroupInvoicesService,
    ClientsService,
    OrderTranslationService,
    $scope
  ) {
    Object.assign(this, {
      GroupInvoicesService,
      ClientsService,
      OrderTranslationService,
      $scope
    });

    this.query = {
      include: ['client'],
      where: {},
      limit: 10,
      page: 1,
      order: 'date DESC'
    };
    this.status = 'all';

    this.getModels();

    this.onPagination = () => {
      this.getModels();
    };

    this.onReorder = () => {
      this.getModels();
    };
  }

  getModels() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    if (this.id) {
      this.clientIds = null;
      this.status = 'all';
      qOpts.where = Object.assign(qOpts.where, {
        id: this.id
      });
    }

    if (this.invoice) {
      Object.assign(qOpts.where, {
        invoiceNumber: {
          ilike: `%${this.invoice}%`
        }
      });
    }

    if (this.clientIds) {
      qOpts.where.clientId = {
        inq: this.clientIds
      };
    }

    if (this.status != 'all') {
      qOpts.where.status = this.status;
    }

    let queryReady = this.GroupInvoicesService.getModels(qOpts).then(
      groupInvoices => {
        this.groupInvoices = groupInvoices;
      }
    );
    let countReady = this.GroupInvoicesService.getCount(qOpts).then(result => {
      this.groupInvoicesCount = result.count;
    });
    return Promise.all([queryReady, countReady]);
  }

  onClientFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.clientIds = clients ? clients.map(c => c.id) : null;
      this.getModels();
    });
  }

  onStatusFilterChange() {
    this.getModels();
  }

  getStatusLabel(status) {
    return getStatusLabel(status);
  }
}

export default GroupInvoicesController;
